import React, { use } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuItem } from '@mui/material';

import AlarmActiveSelect from 'features/residents/resident-settings/components/resident-setting-details-scenario-rows/alarm-active-select';
import {
  ActiveOption,
  useAudioScenarioConfiguration,
} from 'features/residents/resident-settings/components/resident-setting-details-scenario-rows/audio-scenario-configuration/hooks';
import ScenarioTitleRow from 'features/residents/resident-settings/components/resident-setting-details-scenario-rows/scenario-title-row';
import TimeFrames from 'features/residents/resident-settings/components/resident-setting-details-scenario-rows/time-frames/time-frames';
import ResidentSettingsProviderContext from 'features/residents/resident-settings/providers/contexts/resident-settings-provider-context';
import styles from './audio-scenario-configuration.module.scss';

type Props = {
  scenarioTitle: string;
  index: number;
};

const AudioScenarioConfiguration = ({ scenarioTitle, index }: Readonly<Props>): React.JSX.Element => {
  const { t } = useTranslation('residentsSettings');

  const { configuration, timeFrameValuesChanged, onAlarmActiveChanged, determineSelectedActiveOption } = useAudioScenarioConfiguration({
    index,
  });

  const {
    detailEditState: { viewingMode },
  } = use(ResidentSettingsProviderContext);

  const activeOptions = [
    <MenuItem data-testid={`when-active-alarm`} key={`when-active-alarm`} value={ActiveOption.AlarmsOnly}>
      {t('scenarioConfiguration.whenActiveAlarm')}
    </MenuItem>,
    <MenuItem data-testid={`every-situation`} key={`every-situation`} value={ActiveOption.Always}>
      {t('scenarioConfiguration.everySituation')}
    </MenuItem>,
  ];

  return (
    <div className={styles.container}>
      <ScenarioTitleRow scenarioTitle={scenarioTitle} description={t('scenarioConfiguration.scenarioDescription')} />

      <div className={styles.alarmActiveRow}>
        <AlarmActiveSelect
          label={t('scenarioConfiguration.alarmActiveLabel')}
          value={determineSelectedActiveOption()}
          options={activeOptions}
          onChange={onAlarmActiveChanged}
          disabled={viewingMode === 'viewing'}
        />
      </div>

      <TimeFrames
        activeAllDay={configuration.activeAllDay}
        index={index}
        timeFrames={configuration.timeFrames}
        valuesChanged={timeFrameValuesChanged}
        timeFramesDescription={t('scenarioConfiguration.timeFramesDescriptionScenario')}
      />
    </div>
  );
};

export default AudioScenarioConfiguration;
